import styled from '@emotion/styled';
import { useSeparator } from 'react-aria';

import { su } from '../../../theme/functions/su';
import { theme } from '../../../theme/theme';

import { TextSmall } from '../../../components/common/text/TextSmall';

import { VariablesListItem } from './VariablesListItem';

export function VariablesListSection(props) {
  const separator = useSeparator({
    elementType: 'li',
  });

  return (
    <>
      <sc.SectionSeparator {...separator.separatorProps} />
      <sc.Section>
        <sc.SectionHeading color={theme.color.text_light}>{props.title}</sc.SectionHeading>
        <sc.SectionItems>
          {props.variables.map((variable) => {
            return <VariablesListItem key={variable.id} variableId={variable.id} />;
          })}
        </sc.SectionItems>
      </sc.Section>
    </>
  );
}

const sc = {};

sc.SectionSeparator = styled.li`
  // height: 1px;
  // background-color: ${theme.color.line};
`;

sc.Section = styled.li`
  padding: 0;
  margin-bottom: ${su(1)};
`;

sc.SectionHeading = styled(TextSmall)`
  margin: 10px 0 5px 0;
  padding: 0 ${su(2)};
`;

sc.SectionItems = styled.ul``;

sc.SectionEmptyMessage = styled.li`
  display: flex;
  align-items: center;
  height: ${su(5)};
  padding: 0 ${su(1)};
  line-height: 20px;
  color: ${theme.color.text_light};
`;
